import api, { publicApi } from "./api";

/**
 * publicApi.baseURL = https://api.idlogichain.com/api
 * api.baseURL      = https://api.idlogichain.com/api
 *
 * publicApi -> public GET requests
 * api       -> protected requests with JWT
 */

/* =========================
   COUNTRIES
   GET /api/country
   ========================= */
export const fetchCountries = async () => {
    const res = await publicApi.get("/country");
    return res.data;
};

/* =========================
   CITIES
   GET /api/city
   ========================= */
export const fetchCities = async () => {
    const res = await publicApi.get("/city");
    return res.data;
};

/* =========================
   CITY BY ID
   GET /api/city/{id}
   ========================= */
export const fetchCityById = async (id) => {
    const res = await publicApi.get(`/city/${id}`);
    return res.data;
};

/* =========================
   CITIES BY COUNTRY
   GET /api/city/country/{id}
   ========================= */
export const fetchCitiesByCountry = async (countryId) => {
    const res = await publicApi.get(`/city/country/${countryId}`);
    return res.data;
};

/* =========================
   CREATE CITY
   POST /api/city
   ========================= */
export const createCity = async (data) => {
    const res = await api.post("/city", data);
    return res.data;
};

/* =========================
   UPDATE CITY
   PUT /api/city/{id}
   ========================= */
export const updateCity = async (id, data) => {
    const res = await api.put(`/city/${id}`, data);
    return res.data;
};

/* =========================
   DELETE CITY
   DELETE /api/city/{id}
   ========================= */
export const deleteCity = async (id) => {
    const res = await api.delete(`/city/${id}`);
    return res.data;
};

export default {
    fetchCountries,
    fetchCities,
    fetchCityById,
    fetchCitiesByCountry,
    createCity,
    updateCity,
    deleteCity,
};